module.exports = "/static/assets/7318fc38eeca19704bca37e61c899e86.png";